import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="page-container">
      <div className="content-section">
        <p>
          When unexpected damage strikes your home, rental property, or business, urgent repairs
          can't wait. If you're preparing to file an insurance claim, it's essential to ensure you
          receive a comprehensive settlement that fully covers your losses. And if you've already
          started the process but feel let down by your carrier's response, you're not alone.
        </p>
        <p>
          I understand how overwhelming property damage can be, and I'm here to help. As a licensed
          public insurance adjuster, my goal is to ensure your claim is thoroughly assessed, so you
          receive the full compensation you deserve. I handle all types of residential and commercial
          insurance claims, including those for water, fire, storm, wind/hail, and hurricane damage.
        </p>
        <p>
          With years of experience remodeling homes and commercial properties, I have a deep
          understanding of construction, repair costs, and the true impact of damage. Working with
          a public insurance adjuster means there is an insurance expert in your corner. As your
          dedicated advocate, I work exclusively for policyholders like you, ensuring that your best
          interests are represented every step of the way. As a truly independent public insurance
          adjuster, I am not beholden to a big corporation or a boss. I work only for you and you only.
        </p>
        <p>
          Sometimes, clients come to me after they've already started the claims process when they
          feel dissatisfied with the settlement they've been offered. I can help you with the
          supplemental claims process to address any additional damage or overlooked costs, ensuring
          you get the fair compensation you need to fully recover. No matter where you are in the
          claims process, I'm here to support you. Whether it's a new or ongoing claim, my goal is
          to make the process as smooth and stress-free as possible.
        </p>
        <p style={{ textAlign: 'center', marginTop: '12px' }}>
          <Link to="/contact" className="btn">Contact</Link>
          {' '}
          <Link to="/testimonials" className="btn">Testimonials</Link>
        </p>
      </div>
    </div>
  );
}

export default Home;
